// 防多次点击，重复提交

// <el-button v-preventReClick></el-button>

import Vue from 'vue'
import { Message } from 'element-ui'
const preventReClick = Vue.directive('preventReClick', {
  inserted: function (el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 2000)
        // 2种方法
        // el.setAttribute('style', 'pointer-events: none;')
        // setTimeout(() => {
        //   el.setAttribute('style', 'pointer-events: auto;')
        // }, binding.value || 3000)
      }
    })
  },
})

const downloadClick = Vue.directive('downloadClick', {
  inserted: function (el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        Message({
          message: '正在导出请稍后。。20秒内无响应方可再次点击',
          type: 'warning',
        })
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 20000)
        // 2种方法
        // el.setAttribute('style', 'pointer-events: none;')
        // setTimeout(() => {
        //   el.setAttribute('style', 'pointer-events: auto;')
        // }, binding.value || 3000)
      }
    })
  },
})

export { preventReClick, downloadClick }
